// extracted by mini-css-extract-plugin
export default {"content":"Portals_content__Qmx26","header":"Portals_header__I4qUc","back":"Portals_back__etpqG"};